import styled from 'styled-components';
import { variant } from 'styled-system';
import { Box } from '../Box/Box';
import { ColorProps } from '../../../theme/styledProps';

export type ProgressVariant = 'primary' | 'success' | 'error' | 'neutral';

interface ProgressTrackProps {
  isVertical?: boolean;
  isLarge?: boolean;
  isFlat?: boolean;
}

export const ProgressTrack = styled(Box)<ProgressTrackProps>(
  ({ theme, isVertical, isLarge, isFlat, height }) => ({
    height: height || (isVertical ? '100%' : isLarge ? 8 : 4),
    width: isVertical ? (isLarge ? 8 : 4) : '100%',
    overflow: 'hidden',
    borderRadius: !isFlat ? theme.radii.full : 'unset',
    backgroundColor: theme.colors.neutral['200'],
  }),
);

interface ProgressBarProps {
  value: number;
  variant: ProgressVariant;
  isVertical?: boolean;
  isFlat?: boolean;
}

export const ProgressBar = styled(Box).attrs<ProgressBarProps>(({ value, isVertical }) => ({
  // https://github.com/styled-components/styled-components/issues/1212
  style: isVertical ? { height: `${value}%` } : { width: `${value}%` },
}))<ProgressBarProps>(
  ({ theme, isFlat }) => ({
    height: '100%',
    borderRadius: !isFlat ? theme.radii.full : 'unset',
    transition: `width ${theme.transitions.normal}, height ${theme.transitions.normal}`,
  }),

  variant<ColorProps, ProgressVariant>({
    prop: 'variant',
    variants: {
      neutral: { bg: 'neutral.400' },
      primary: { bg: 'primary.500' },
      success: { bg: 'success.500' },
      error: { bg: 'error.500' },
    },
  }),
);
